import * as React from 'react';
import { useEffect } from 'react';
import Button from '@mui/material/Button';
import { Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Register from "../images/register now screen 02.json";
import Lottie from 'lottie-react';
import { useNavigate } from 'react-router-dom';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide(props) {
  const { open, setOpen, onRedirect, setError, setRegistered, checkFunction, onRegisterSuccess } = props;
  const navigate = useNavigate();
  const redirectTimerRef = React.useRef(null);
  const registerSuccessCalledRef = React.useRef(false);

  const handleClose = () => {
    if (setOpen) {
      setOpen(false);
    }
  };

  // API call when drawer opens
  useEffect(() => {
    registerSuccessCalledRef.current = false;
    const makeApiCall = async () => {
      if (open) {
        try {
          const params = new URLSearchParams(window.location.search);
          let ck_id = params.get('userid') || params.get('user_id') || params.get('userId') || params.get('ck_id') || params.get('ckid');
          console.log(ck_id);
          
          if (ck_id != null && ck_id != 'null') {
            let response = await fetch(`${process.env.REACT_APP_SITE_URL_VP}/api/user/create_mb_feb?userId=${ck_id}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              }
            });
            response = await response.json();
            
            if (response?.message == 'This is not lapsed user.') {
              if (setError) {
                setError(true);
              }
              handleClose();
              return;
            }
            
            localStorage.setItem('mb_ck_id_march_new_cg', response.ck_id);
            if (setRegistered) {
              setRegistered(true);
            }
            // After register success: close drawer and show open mystery box (e.g. open modal)
            if (onRegisterSuccess && !registerSuccessCalledRef.current) {
              registerSuccessCalledRef.current = true;
              if (redirectTimerRef.current) {
                clearTimeout(redirectTimerRef.current);
                redirectTimerRef.current = null;
              }
              onRegisterSuccess();
              handleClose();
            }
          }
        } catch (error) {
          console.log(error.message);
          if (setError) {
            setError(true);
          }
          handleClose();
        }
      }
    };

    makeApiCall();
  }, [open]);

  // Note: no auto-reload here; reloading causes API/redirect loops.

  return (
    <Dialog
      open={open || false}
      TransitionComponent={Transition}
      keepMounted
      onClose={(event, reason) => {
        // Prevent closing by clicking outside or pressing escape during the 5 second period
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
        handleClose();
      }}
      aria-describedby="alert-dialog-slide-description"
      fullWidth
      maxWidth={false}
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          width: '100%',
          height: '100%',
          maxWidth: '100%',
          maxHeight: '100%',
          margin: 0,
          borderRadius: 0,
          backgroundImage: "url(https://d2sriifpjiqv0p.cloudfront.net/mystery-box/bgRes.png)",
          backgroundSize: '100% 100%',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }
      }}
    >
      
      <DialogContent>
      <Box sx={{display: 'flex',
                  justifyContent: 'center',}}>
            <Lottie
              animationData={Register}
              loop
              autoplay
              style={{ width: "100%",}}
            />
          </Box>
      </DialogContent>
    </Dialog>
  );
}
